import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "../lib/auth";
import NotificationBell from "../components/NotificationBell";
import { toast } from "sonner";

const navItems = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/laporan", label: "Semua Laporan", icon: FileText, end: false },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    toast.success("Berhasil keluar");
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen flex bg-slate-50" data-testid="admin-layout">
      {/* SIDEBAR */}
      <aside className="w-64 bg-[#0B2B5E] text-white flex-shrink-0 flex flex-col relative overflow-hidden">
        <div className="absolute inset-0 bg-grid-dark opacity-20 pointer-events-none" aria-hidden />
        <div className="relative px-6 py-6 border-b border-white/10">
          <Link to="/admin" className="flex items-center gap-3" data-testid="admin-logo">
            <img
              src="/img/logo2.png"
              alt="Ditresnarkoba Polda Jateng"
              className="h-11 w-11 shrink-0 object-contain drop-shadow-sm"
            />
            <div className="leading-tight">
              <div className="text-[10px] tracking-[0.22em] uppercase text-[#FACC15] font-semibold">
                Ditresnarkoba
              </div>
              <div className="font-display font-extrabold text-sm">Polda Jateng</div>
            </div>
          </Link>
        </div>

        <nav className="relative flex-1 px-3 py-6 space-y-1">
          <div className="text-[10px] tracking-[0.22em] uppercase text-slate-400 px-3 mb-3">
            Navigasi
          </div>
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`sidebar-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-semibold transition-colors ${
                  isActive
                    ? "bg-white/10 text-white border border-white/10"
                    : "text-slate-300 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <n.icon className="h-4 w-4" />
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="relative px-4 pb-5 border-t border-white/10 pt-5 space-y-3">
          <Link
            to="/"
            data-testid="admin-public-view"
            className="flex items-center gap-2 text-xs text-slate-300 hover:text-white"
          >
            <ExternalLink className="h-3.5 w-3.5" />
            Lihat portal publik
          </Link>
          <div className="rounded-md bg-white/5 border border-white/10 p-3">
            <div className="text-[10px] uppercase tracking-wider text-slate-400">
              Masuk sebagai
            </div>
            <div className="mt-1 font-semibold text-sm truncate" data-testid="admin-user-email">
              {user?.name || user?.email}
            </div>
          </div>
          <button
            onClick={doLogout}
            data-testid="admin-logout-btn"
            className="w-full inline-flex items-center gap-2 rounded-md bg-[#FACC15] text-[#0B2B5E] px-3 py-2 text-xs font-bold hover:bg-yellow-300 transition-colors"
          >
            <LogOut className="h-3.5 w-3.5" />
            Keluar
          </button>
        </div>
      </aside>

      {/* MAIN */}
      <main className="flex-1 flex flex-col min-w-0">
        <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-slate-200 px-6 py-3 flex items-center justify-between">
          <div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-slate-500 font-semibold">
              Dashboard Petugas
            </div>
            <div className="font-display font-bold text-[#0F172A]">
              Sistem Pelaporan Narkotika
            </div>
          </div>
          <div className="flex items-center gap-3">
            <NotificationBell />
          </div>
        </header>
        <div className="flex-1 p-6 lg:p-8 overflow-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
